import { render, staticRenderFns } from "./AccordionHelpItems.vue?vue&type=template&id=7a80fa51&"
import script from "./AccordionHelpItems.vue?vue&type=script&lang=js&"
export * from "./AccordionHelpItems.vue?vue&type=script&lang=js&"
import style0 from "./AccordionHelpItems.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/www/betsur.net.ar/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7a80fa51')) {
      api.createRecord('7a80fa51', component.options)
    } else {
      api.reload('7a80fa51', component.options)
    }
    module.hot.accept("./AccordionHelpItems.vue?vue&type=template&id=7a80fa51&", function () {
      api.rerender('7a80fa51', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/pages/parts/helpItems/AccordionHelpItems.vue"
export default component.exports